import { render, staticRenderFns } from "./AttributesImagesModal.vue?vue&type=template&id=278ca5d4&scoped=true"
import script from "./AttributesImagesModal.vue?vue&type=script&lang=js"
export * from "./AttributesImagesModal.vue?vue&type=script&lang=js"
import style0 from "./AttributesImagesModal.vue?vue&type=style&index=0&id=278ca5d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278ca5d4",
  null
  
)

export default component.exports